import angular from 'angular';
import SprintCreatorPopupComponent from './creator/sprint-creator-popup.component';
import SprintEditorPopupComponent from './editor/sprint-editor-popup.component';
import './styles.css';


const sprintPopup = angular.module('ttb.core.popups.sprintPopup', [])
  .component('sprintCreatorPopup', SprintCreatorPopupComponent)
  .component('sprintEditorPopup', SprintEditorPopupComponent)
  .name;

export default sprintPopup;



// WEBPACK FOOTER //
// ./components/popups/sprint/index.js